import styled from "styled-components";
import { device } from "./Device";
import background from "../assets/images/background-final.png";
import logo from "../assets/images/new-logo.png";
import footerBg from "../assets/images/pink-rect-footer.png";

export const MainImage = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  background-image: url(${background});
  background-size: cover;
  background-position: center;
  filter: grayscale(100%);
  z-index: -1;
`;

export const FooterImage = styled.div`
  width: 100%;
  box-sizing: border-box;

  background-image: url(${footerBg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;

  display: flex;
  flex-direction: column;
  margin-top: auto;
  position: absolute;
  bottom: 0;
  left: 0;

  justify-content: flex-end;
  align-items: flex-start;
  overflow: hidden;
  text-align: center;

  @media ${device.mobileS} {
    padding: 0;
    gap: 1.2vw;
    height: 11vh;
  }

  @media ${device.mobileM} {
    padding: 0;
    gap: 1.2vw;
    height: 11vh;
  }

  @media ${device.laptop} {
    padding: 2.5vh 0;
    gap: 0.5vw;
    height: 14vh;
  }

  @media ${device.laptopL} {
    padding: 2.5vh 0;
    gap: 0.5vw;
    height: 14.5vh;
  }
`;

export const LogoImage = styled.div`
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  @media ${device.mobileS} {
    width: 30vw;
    height: 10vh;
  }

  @media ${device.mobileM} {
    width: 30vw;
    height: 10vh;
  }

  @media ${device.mobileL} {
    width: 30vw;
    height: 10vh;
  }

  @media ${device.tablet} {
    width: 20vw;
    height: 11vh;
  }

  @media ${device.laptop} {
    width: 10vw;
    height: 11vh;
  }

  @media ${device.laptopL} {
    width: 10vw;
    height: 12vh;
  }

  @media ${device.desktop} {
    width: 10vw;
    height: 12vh;
  }
`;

export const TinyLogoImage = styled.div`
  background-image: url(${logo});
  margin-left: 0.5vw;

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  @media ${device.mobileS} {
    height: 5vh;
    width: 5vh;
  }

  @media ${device.tablet} {
    height: 6vh;
    width: 6vh;
  }

  @media ${device.laptop} {
    height: 6vh;
    width: 6vh;
  }

  @media ${device.laptopL} {
    height: 7vh;
    width: 7vh;
  }

  @media ${device.desktop} {
    height: 8vh;
    width: 8vh;
  }
`;
